import Tooltip from '@material-ui/core/Tooltip';
import { NumberInput, DropdownInput } from '@trueprodigy/components';
import TextInput from '@components/TextInputCaseSetting';
import _ from 'lodash';
// import moment from 'moment';
import React from 'react';
import { Field } from 'redux-form/immutable';
import styled from 'styled-components';
import KeyboardDateInput from '@components/KeyboardDateInput';

export const getEventForm = (eventFormList, formID) => {
  if (!eventFormList.get('data') || !formID) {
    return {};
  }

  return eventFormList
    .get('data')
    .toJS()
    .find(eventForm => eventForm.formID === parseInt(formID, 10));
};

export const parseDate = date => {
  const dt = new Date(date);
  return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`;
};

export const SelectWrapper = styled.div`
  margin-bottom: 15px;

  & > div {
    width: 100%;
  }
`;

const requireValidator = value =>
  value || typeof value === 'number' ? undefined : 'Required';
export const renderFormFields = fields =>
  fields
    .sort((field1, field2) => field1.order - field2.order)
    .map((field, key) => {
      switch (field.type) {
        case 'integer':
        case 'currency':
          return field.helpText ? (
            <Tooltip key={key} title={field.helpText}>
              <Field
                InputProps={{ inputComponent: NumberInput }}
                component={TextInput}
                label={field.name}
                name={`eventData.${field.name}`}
                validate={field.isRequired === 1 ? [requireValidator] : []}
              />
            </Tooltip>
          ) : (
            <Field
              InputProps={{ inputComponent: NumberInput }}
              component={TextInput}
              key={key}
              label={field.name}
              name={`eventData.${field.name}`}
              validate={field.isRequired === 1 ? [requireValidator] : []}
            />
          );
        case 'number':
        case 'text':
          return field.helpText ? (
            <Tooltip key={key} title={field.helpText}>
              <Field
                component={TextInput}
                multiline={true}
                label={field.name}
                name={`eventData.${field.name}`}
                type={field.type}
                validate={field.isRequired === 1 ? [requireValidator] : []}
              />
            </Tooltip>
          ) : (
            <Field
              component={TextInput}
              multiline={true}
              key={key}
              label={field.name}
              name={`eventData.${field.name}`}
              type={field.type}
              validate={field.isRequired === 1 ? [requireValidator] : []}
            />
          );
        case 'datetime':
          return field.helpText ? (
            <Tooltip key={key} title={field.helpText}>
              <Field
                component={KeyboardDateInput}
                dateFormat="MM/dd/yyyy"
                label={field.name}
                name={`eventData.${field.name}`}
                defaultToNow={false}
                validate={field.isRequired === 1 ? [requireValidator] : []}
              />
            </Tooltip>
          ) : (
            <Field
                component={KeyboardDateInput}
                dateFormat="MM/dd/yyyy"
                key={key}
                label={field.name}
                name={`eventData.${field.name}`}
                defaultToNow={false}
                validate={field.isRequired === 1 ? [requireValidator] : []}
              />
          );
        case 'selection':
          return (
            <SelectWrapper key={key}>
              {field.helpText ? (
                <Tooltip title={field.helpText}>
                  <Field
                    component={DropdownInput}
                    label={field.name}
                    name={`eventData.${field.name}`}
                    options={(field.options || []).map(t => ({
                      value: t,
                      label: t,
                    }))}
                    validate={field.isRequired === 1 ? [requireValidator] : []}
                    normalize={v => v.value}
                  />
                </Tooltip>
              ) : (
                <Field
                  component={DropdownInput}
                  label={field.name}
                  name={`eventData.${field.name}`}
                  options={(field.options || []).map(t => ({
                    value: t,
                    label: t,
                  }))}
                  validate={field.isRequired === 1 ? [requireValidator] : []}
                  normalize={v => v.value}
                />
              )}
            </SelectWrapper>
          );
      }
    });

export const formatEventValues = (event, formFields) => {
  const eventClone = _.cloneDeep(event);
  formFields.forEach(field => {
    if (field.type === 'currency' && eventClone.eventData) {
      eventClone.eventData[field.name] = parseFloat(
        eventClone.eventData[field.name],
      ).toFixed(2);
    }
  });
  if (!eventClone.eventData || eventClone.eventData.length === 0) {
    eventClone.eventData = {};
  }
  return eventClone;
};

export const defaultEventValues = (formFields, persists) => {
  const event = { eventData: {}, eventType: persists.eventType };
  formFields.forEach(field => {
    if (field.persist && persists.eventData[field.name]) {
      event.eventData[field.name] = persists.eventData[field.name];
    }
    // if (field.defaultValue && !event.eventData[field.name]) {
    //   event.eventData[field.name] =
    //     field.type === 'datetime'
    //       ? moment(field.defaultValue).format('YYYY-MM-DD')
    //       : field.defaultValue;
    // }
  });

  return event;
};

export const formatEventData = (event, formFields) => {
  if (!event.eventData) {
    event.eventData = {};
  }

  formFields.forEach(field => {
    if (field.type === 'integer') {
      event.eventData[field.name] = parseInt(event.eventData[field.name], 10);
    } else if (field.type === 'currency') {
      event.eventData[field.name] = parseFloat(event.eventData[field.name]);
    }
  });
};
